import { useEffect, useState } from 'react'

import { useCheckMicrophonePermission } from '@core/devicePermissions/useCheckMicrophonePermission'

/**
 * A hook that checks the microphone permission status on a regular interval.
 */
export const useMicrophonePermission = () => {
  const { checkPermissionStatus } = useCheckMicrophonePermission({})

  const [permission, setPermission] = useState<PermissionState | 'unknown'>(
    'unknown',
  )

  useEffect(() => {
    async function checkPermission() {
      const permission = await checkPermissionStatus()
      setPermission(permission)
    }

    const interval = setInterval(() => {
      checkPermission()
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [checkPermissionStatus])

  return permission
}
